/**
 * @generated SignedSource<<b78c52743534071afe4898e9719c96dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type videoGenerationModelsQuery$variables = Record<PropertyKey, never>;
export type videoGenerationModelsQuery$data = {
  readonly videoGenerationModels: ReadonlyArray<{
    readonly allowedAspectRatios: ReadonlyArray<string>;
    readonly allowedDurations: ReadonlyArray<number>;
    readonly allowedResolutions: ReadonlyArray<string>;
    readonly maxPromptLength: number;
    readonly model: string;
    readonly supportsGenerateAudio: boolean;
  }>;
};
export type videoGenerationModelsQuery = {
  response: videoGenerationModelsQuery$data;
  variables: videoGenerationModelsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "VideoGenerationModelInfo",
    "kind": "LinkedField",
    "name": "videoGenerationModels",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "model",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxPromptLength",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowedDurations",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowedResolutions",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "allowedAspectRatios",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "supportsGenerateAudio",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "videoGenerationModelsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "videoGenerationModelsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "d80f79d64304c9d3607b2567792dab94",
    "id": null,
    "metadata": {},
    "name": "videoGenerationModelsQuery",
    "operationKind": "query",
    "text": "query videoGenerationModelsQuery {\n  videoGenerationModels {\n    model\n    maxPromptLength\n    allowedDurations\n    allowedResolutions\n    allowedAspectRatios\n    supportsGenerateAudio\n  }\n}\n"
  }
};
})();

(node as any).hash = "934d565c3bf12592782822f3dc5b4de0";

export default node;
